import { AsyncThunkAction } from '@reduxjs/toolkit';

export const takeLeadingThunk =
  <T, R>(
    thunk: (arg: T) => AsyncThunkAction<R, T, any>
  ) =>
  () => {
    let isProcessing = false;

    return (payload: T) => async (dispatch: any) => {
      if (isProcessing) return;
      isProcessing = true;

      try {
        await dispatch(thunk(payload)).unwrap(); 
      } catch (error) {
        console.error("Error in takeLeadingThunk:", error);
      } finally {
        isProcessing = false;
      }
    };
  };